/**
Copyright 2021 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
//import { PrimeConfig } from "../externalLib";
// eslint-disable-next-line import/no-anonymous-default-export
const mountingPoints = {
  catalogContainer: ".catalog__container",
  trainingOverviewPage: ".training__page__container",
  boardsContainer: ".boards__container",
  boardContainer: ".board__container",
  badgesContainer: ".badges__container",
  notificationContainer: ".notification__container",
  instanceContainer: ".instance__container",
  profilePageContainer: ".profile__container",
  authorContainer: ".author__container",
  activeFieldsContainer: ".activeFields__container",
  navigationBarContainer: ".navigationBar__container",
  mastHeadContainer: ".mastHead__container",
  categoryBrowserContainer: ".categoryBrowser__container",
  footerContainer: ".footer__container",
  myLearningContainer:".cmp__my_learning",
  certificationContainer:".certificate_badge__container",
  skillsContainer:".skills__container",
  surveyContainer:".survey-react-mount"
};

(window as any).ALM = (window as any).ALM || {};
(window as any).ALM.ALMConfig = (window as any).ALM.ALMConfig || {};
(window as any).ALM.ALMConfig["mountingPoints"] = mountingPoints;

export { mountingPoints };
